<script>
import control from "@/control";

export default {
  mixins: [control],
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      errors: null,
    };
  },
  computed: {
    availability() {
      if (!this.form) return;
      return {
        date: this.form?.date,
        provider_id: this.form?.provider_id,
        location_id: this.form?.location?.location_id,
        time: {
          start: this.form?.start,
          operatory_id: this.form?.operatory_id,
          hash: this.form?.hash,
        },
      };
    },
    component() {
      return `sameday-form-step-${this.step}`;
    },
  },
  methods: {
    onField({ key, value }) {
      this.control[key] = value;
    },
    onStep(value) {
      if (!value) return;
      this.step = value;
    },
    onError(response) {
      this.errors = {};
      this.errors.validation = response?.errors[0]?.extensions.validation;
      this.errors.message = response?.errors[0]?.message;
    },
    onAgain() {
      this.step = 1;
    },
  },
  mounted() {
    this.onField({
      key: "availability",
      value: this.availability,
    });
    this.onField({
      key: "services",
      value: this.form?.service,
    });
    this.onField({
      key: "locations",
      value: this.form?.location,
    });
  },
  render() {
    return this.$scopedSlots.default({
      data: {
        input: this.input,
        control: this.control,
        errors: this.errors,
        component: this.component,
      },
      methods: {
        onField: this.onField,
        onStep: this.onStep,
        onError: this.onError,
        onAgain: this.onAgain,
      },
    });
  },
};
</script>
